import * as React from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogSurface,
    DialogTitle,
    Tab,
    TabList,
    SelectTabData,
    SelectTabEvent,
} from "@fluentui/react-components";
import { AddressManagementSection } from "./dataManagement/AddressManagementSection";
import { BankManagementSection } from "./dataManagement/BankManagementSection";
import { CommunicationManagementSection } from "./dataManagement/CommunicationManagementSection";
import { Address, Bank, Communication } from "./dataManagement/types";

type DataManagementModalProps = {
    open: boolean;
    onClose: (open: boolean) => void;
    contactId: number;
    contactName: string;
    addresses: Address[];
    banks: Bank[];
    communications: Communication[];
    relations: any[];
    erreichbarkeit?: string;
    initialTab?: "addresses" | "banks" | "communications";
    onUpdateErreichbarkeit?: (val: string) => void;
};

export const DataManagementModal: React.FC<DataManagementModalProps> = ({
    open,
    onClose,
    contactId,
    contactName,
    addresses,
    banks,
    communications,
    erreichbarkeit,
    initialTab = "addresses",
    onUpdateErreichbarkeit,
}) => {
    const [selectedTab, setSelectedTab] = React.useState<string>(initialTab);

    React.useEffect(() => {
        if (open) {
            setSelectedTab(initialTab);
        }
    }, [open, initialTab]);

    const handleTabSelect = (_event: SelectTabEvent, data: SelectTabData) => {
        setSelectedTab(data.value as string);
    };

    const handleClose = () => {
        onClose(false);
    };

    return (
        <Dialog open={open} onOpenChange={(_, data) => (data.open ? null : handleClose())}>
            <DialogSurface style={{ width: "1200px", maxWidth: "95vw", maxHeight: "90vh", overflowY: "auto" }}>
                <DialogTitle>Daten ändern - {contactName}</DialogTitle>
                <DialogContent>
                    <TabList selectedValue={selectedTab} onTabSelect={handleTabSelect}>
                        <Tab value="addresses">Anschriften</Tab>
                        <Tab value="communications">Kommunikation</Tab>
                        <Tab value="banks">Bankverbindungen</Tab>
                    </TabList>

                    {selectedTab === "addresses" && (
                        <AddressManagementSection contactId={contactId} addresses={addresses} />
                    )}

                    {selectedTab === "communications" && (
                        <CommunicationManagementSection
                            contactId={contactId}
                            communications={communications}
                            erreichbarkeit={erreichbarkeit}
                            onUpdateErreichbarkeit={onUpdateErreichbarkeit}
                        />
                    )}

                    {selectedTab === "banks" && (
                        <BankManagementSection contactId={contactId} banks={banks} />
                    )}
                </DialogContent>
                <DialogActions style={{ marginTop: 20 }}>
                    <Button onClick={handleClose}>Schließen</Button>
                </DialogActions>
            </DialogSurface>
        </Dialog>
    );
};

export type { Address, Bank, Communication } from "./dataManagement/types";
export { AddressManagementSection, BankManagementSection, CommunicationManagementSection };
